module.exports = __webpack_public_path__ + "Server-Disabled.AzureCloudService.0898c99e7936527cee9d4142251116a9.hashedasset.svg";